/**
   Local Storage Namespaces

   Naming Conventions:
   - The namespace is made of three parts, one mandatory and two optional.
   - Structure: [HEAD]_[BODY]_[MODIFIER]
   - Head is mandatory whilst body and modifier are optional.
   - The value should be written using camelCase,
     whilst the key should be written as a constant with underscore separators.

   Example:
      Key: CART_USER_HAS_ACCESS -> [CART]_[USER]_[HAS_ACCESS]
      Value: cartUserHasAccess
 */

export default {
    CATNAV: 'CatNav',
    CAT_NAV_LOCALE: 'CatNavLocale',
    USER_DATA: 'UserData',
    BASKET: 'basket',
    BASKET_TYPE: 'basketType',
    INIT_ORDER_ID: 'lastUfeInitOrderId',
    LAST_INIT_CHECKOUT_PAYLOAD: 'lastInitCheckoutPayload',
    PAGE_LOAD_FLAG: 'PageLoadFlag',
    LITHIUM_API_TOKEN: 'LithiumApiToken',
    LITHIUM_DATA: 'LITHIUM_DATA',
    LOVES_DATA: 'LOVES_DATA',
    PAGE_DISPLAY_COUNT: 'PageDisplayCount',
    REFERRER: 'Referrer',
    SIGN_IN_SEEN: 'SignInSeen',
    SAVE_POINTS_FOR_GUEST: 'SavePointsForGuest',
    PROFILE_POPOVER_DISMISSED: 'ProfilePopoverDismissed',
    PROFILE_POPOVER_DISPLAY_COUNT: 'ProfilePopoverDisplayCount',
    BI_PANEL_HAS_BEEN_OPENED: 'BIPanelHasBeenOpened',
    APPLE_PAY_ELIGIBILITY: 'applePayEligibility',
    RRC_TERMS_CONDITIONS_ACCEPTED: 'rrcTermsConditionsAccepted',
    RRC_TERMS_CONDITIONS_CHECKED: 'rrcTermsConditionsChecked',
    INITIAL_LOAD_WELCOME_MAT: 'initialLoadWelcomeMat',
    WELCOME_MAT_LAST_TIME_SEEN: 'welcomeMatLastTimeSeen',
    OLR_AUTH_TOKEN: 'olrAuthToken',
    BV_AUTH_TOKEN: 'bvAuthToken',
    UFE_AUTH_TOKEN: 'ufeAuthToken',
    EXPERIENCE_LOCATION: 'userLocation',
    PREVIOUS_EXPERIENCE_LOCATIONS: 'previousUserLocations',
    OLR_RESCHEDULE_EXPERIENCE_NUMBER: 'olrRescheduleExperienceNumber',
    CREDIT_CARD_REALTIME_PRESCREEN: 'realtimePrescreen',
    CREDIT_CARD_TARGETERS: 'ccTargeters',
    LOVED_ITEMS_WITH_DETAILS: 'lovedItemsFlatListWithDetails',
    LOVED_ITEMS_SKU_ONLY: 'lovedItemsFlatListSkuOnly',
    LIMITED_LOVED_ITEMS: 'limitedLovedItemsFlatList',
    ALL_LOVE_LIST: 'allLovedLists',
    ALL_LOVE_LIST_SKU_ONLY: 'allLovedListsSkuOnly',
    HARMONY_CONVERSION_ID: 'harmonyConversionId',
    TARGET_CAMPAIGN: 'targetCampaign',
    TARGET_PROMO: 'targetPromo',
    TARGET_REFERRER: 'targetReferrer',
    TARGET_PRODUCT_PAGE_TYPE: 'targetProductPageType',
    HAS_PREVIOUSLY_LOGGED_IN: 'hasPreviouslyLoggedIn',
    PASSKEY_OPTIN_DISMISSED: 'passkeyOptinDismissed',
    PASSKEY_OPTIN_TRACKING: 'passkeyOptinTracking',
    PASSKEY_OPTIN_PENDING_AFTER_RELOAD: 'passkeyOptinPendingAfterReload',
    CREATED_NEW_USER: 'createdNewUser',
    USER_HAS_SEEN_UPDATED_SHIPPING_CALCULATIONS: 'userHasSeenUpdatedShippingCalculations',
    CONSTRUCTOR_PURCHASE_EVENT_ORDER_CONF: 'constructorPurchaseEventFired',
    SELECTED_STORE: 'selectedStore',
    IS_BIREGISTER_MODAL_DISMISSED: 'isBiRegisterModalDismissed',
    PICKUP_STORE: 'pickupStore',
    IASP_INCLUDE_NEARBY_STORES: 'iaspIncludeNearbyStores',
    IS_CALIFORNIA_CONSUMER: 'isCaliforniaConsumer',
    PREFERRED_ZIP_CODE: 'preferredZipCode',
    SAME_DAY_DELIVERY_AVAILABLE: 'sameDayDeliveryAvailable',
    EDIT_SEPHORA_CARD: 'editSephoraCard',
    PAYMENT_PROMO_BANNER: 'paymentPromoBanner',
    MAX_ADDRESS_VALIDATION_COUNT: 'maxAddressValidationCount',
    SEARCH_TERM_PERSIST: 'searchTermPersist',
    EDP_POLICIES: 'edpPolicies',
    PERSONALIZED_PROMOTIONS: 'personalizedPromotions',
    PERSONALIZED_PROMOTIONS_V2: 'personalizedPromotionsV2',
    JWT_AUTH_TOKEN: 'jwtAuthToken',
    HIDE_OAFL_NOTIFICATION: 'hideOnlyAFewLeftNotification',
    LAST_ORDER_TYPE: 'lastOrderType',
    AUTH_ACCESS_TOKEN: 'accessToken',
    AUTH_REFRESH_TOKEN: 'refreshToken',
    NCR_ORDER: 'ncrOrder',
    NCR_ORDER_ERROR_MESSAGE: 'ncrOrderErrorMessage',
    NCR_PRODUCTS_STRING: 'ncrProductsString',
    CAPTURED_COLOR_IQ_PREF: 'capturedColorIQPref',
    USER_ACCOUNT_CLOSED: 'userAccountClosed',
    GALLERY_GREETINGS_DISPLAYED: 'galleryGreetingsDisplayed',
    LOGIN_PROFILE_WARNINGS: 'loginProfileWarnings',
    POSTPONE_LOGIN_PROFILE_WARNINGS: 'postponeLoginProfileWarnings',
    SPLIT_EDD_EXPERIENCE: 'splitEDDExperience',
    ANALYTICS_NEXT_PAGE_DATA: 'anaNextPageData',
    BI_ACCOUNT_ID: 'biAccountId',
    PROFILE_ID: 'profileId',
    USER_EMAIL: 'userEmail',
    CAN_CHECKOUT_PAZE: 'canCheckoutPaze',
    P13N_DATA: 'P13N_DATA',
    AUTO_REPLENISH_CONTENT: 'autoReplenishContent',
    PDP_SAMPLES_MODAL: 'pdpSamplesModal',
    LAST_USER_INTERACTION: 'lastUserInteraction',
    PROFILE_SECURITY_STATUS: 'profileSecurityStatus',
    USER_DIDNT_INTERACT: 'userDidntInteract',
    RUPEX_PREVIEW_DATA: 'rupexPreviewData',
    BAZAAR_STATS_REVIEW_DATA: 'bazaarStatsReviewData',
    CUSTOMER_OBJECT: 'cust360',
    DISABLE_BEAUTY_PREFERENCES_SPOKE: 'disableBeautyPreferencesSpoke',
    BI_OFFERS: 'biOffers',
    HAS_IDENTITY: 'hasIdentity',
    REFINEMENTS: 'refinements',
    GLADLY_CHAT: 'gladlyChat',
    MARKETING_REFERRER: 'marketing_referrer',
    OM_MMC_PARAMETER: 'om_mmc',
    VENMO_FLOW: 'venmoFlow',
    VENMO_STARTED: 'venmoStarted',
    CSF_ATTRIBUTION_DATA: 'csfAttributionData',
    CSF_ADOBE_TRACKING_CODE: 'csfAdobeTrackingCode',
    CSF_DYNAMIC_COMMISSIONING_DATA: 'csfDynamicCommissioningData',
    LINKSHARE_SITE_ID: 'linkshareSiteId',
    CLICK_ID_PARAMETER: 'ScCid',
    SHOP_STORE_AND_DELIVERY_FLYOUT: 'ShopStoreAndDeliveryFlyout',
    SHOP_STORE_AND_DELIVERY_CONTEXT_KEY: 'ShopStoreAndDeliveryContext',
    CACHE_ALL_LIST: 'cacheAllList',
    CACHE_ALL_LIST_SKUS_ONLY: 'cacheAllListSkusOnly',
    CACHE_FULL: 'cacheFull',
    CACHE_BASIC: 'cacheBasic',
    CACHE_LIMITED_LOVE_LIST: 'cacheLimitedLoveList',
    STAY_SIGN_IN: 'staySignIn',
    // Confetti device-scoped flags bp redesign
    CONFETTI_SEEN_MOMENT_1: 'confettiSeen_moment1',
    CONFETTI_SEEN_MOMENT_2: 'confettiSeen_moment2',
    FRICTIONLESS_CHECKOUT_PAGE_ANALYTICS: 'fcAnalyticsForSection',
    MY_LISTS_SCROLL_POSITION: 'myListsScrollPosition',
    MY_CUSTOM_LIST_SCROLL_POSITION: 'myCustomListScrollPosition',
    // IndexedDB keys for Product Comparison Tool
    COMPARE_MODE_KEY: 'productCompare_isEnabled',
    COMPARE_PRODUCTS_KEY: 'productCompare_selectedProducts',
    // localStorage key to reopen Compare Modal after returning from PDP via back navigation
    COMPARE_MODAL_OPEN_KEY: 'productCompare_modalOpen',
    COMPARE_MODAL_SCROLL_POSITION_KEY: 'productCompare_modalScrollPosition',
    // External Auth (OAuth2) Integration
    EXTERNAL_AUTH_SESSION_ID: 'externalAuthSessionId',
    EXTERNAL_AUTH_PARAMS: 'externalAuthParams',
    REWARDS_PURCHASED_GROUPS: 'rewardsPurchasedGroups',
    TRENDING_OFFERS: 'trendingOffers',
    TRENDING_OFFERS_DEVICE_ID: 'trendingOffersDeviceId',
    LOCATION_CACHE_KEY: 'getLocationCache'
};
